import PropTypes from 'prop-types';
import React from 'react';
import screens from '../utils/screens';
import getWindow from '@loggi/js/get-window';

const sizesKeys = Object.keys(screens.sizes);
const $window = __NATIVE__ ? null : getWindow();

class Display extends React.Component {
  static displayName = 'Display';

  static propTypes = {
    ...sizesKeys.reduce((obj, size) => {
      obj[size] = PropTypes.bool;
      return obj;
    }, {}),
    when: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
      .isRequired,
    onChange: PropTypes.func,
    media: PropTypes.string
  };

  static defaultProps = {
    ...sizesKeys.reduce((obj, size) => {
      obj[size] = false;
      return obj;
    }, {}),
    when: true
  };

  constructor(props) {
    super(props);

    this._onResize = this._onResize.bind(this);
    this._matchMediaListener = null;

    this.state = {
      isVisible: null
    };
  }

  componentDidMount() {
    this._addMatchMediaListener();
    if ($window) {
      $window.addEventListener('resize', this._onResize);
    }
    this._update();
  }

  componentWillUnmount() {
    this._removeMatchMediaListener();
    if ($window) {
      $window.removeEventListener('resize', this._onResize);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.media !== this.props.media) {
      this._removeMatchMediaListener();
      this._addMatchMediaListener(nextProps);
    }
  }

  componentDidUpdate() {
    this._update();
  }

  render() {
    const { isVisible } = this.state;
    const { children } = this.props;

    if (isVisible) {
      return typeof children === 'function' ? children() : children;
    }

    return null;
  }

  _onResize() {
    this._update();
  }

  _matchMedia(props) {
    const media = props ? props.media : this.props.media;
    return !media || ($window && !$window.matchMedia)
      ? false
      : $window && $window.matchMedia(media);
  }

  _removeMatchMediaListener() {
    if (this._matchMediaListener) {
      this._matchMediaListener.removeListener(this._onResize);
    }
  }

  _addMatchMediaListener(props) {
    const matchMedia = this._matchMedia(props || this.props);
    if (matchMedia) {
      this._matchMediaListener = matchMedia;
      this._matchMediaListener.addListener(this._onResize);
    }
  }

  _update() {
    const { isVisible: currentIsVisible } = this.state;

    const currentScreen = screens.getScreen();
    const { when } = this.props;
    const matchWhen = typeof when === 'function' ? when() : when;
    const hasBreakpointProp = sizesKeys.some(key => this.props[key]);
    const matchBreakpoint = !hasBreakpointProp
      ? true
      : sizesKeys.reduce((bool, key) => {
          if (this.props[key]) {
            if (currentScreen === screens.sizes[key]) {
              bool = true;
            }
          }

          return bool;
        }, false);

    const matchMedia = this._matchMedia();

    const isVisible =
      matchBreakpoint && (!matchMedia || matchMedia.matches) && matchWhen;

    if (isVisible !== currentIsVisible) {
      this.setState({
        isVisible
      });
      if (this.props.onChange) {
        this.props.onChange(currentScreen, isVisible);
      }
    }
  }
}

export default Display;
